import React from 'react';
import { findDOMNode } from 'react-dom';
import { List } from 'react-virtualized';
import { observer } from 'mobx-react-lite';
import { Draggable, Droppable, } from 'react-beautiful-dnd';
import classnames from 'classnames';
import QuoteItem from './QuoteItem';
export const getBackgroundColor = (isDraggingOver, isDraggingFrom) => {
    if (isDraggingOver) {
        return 'rgb(222, 235, 255)';
    }
    if (isDraggingFrom) {
        return "rgb(255, 250, 230)";
    }
    return "white";
};
export const getDraggingStyle = (isDraggingOver, isDraggingFrom) => {
    if (isDraggingOver) {
        return {
            background: 'rgba(8,64,248,0.02)',
            border: '1px dashed #82ACFF',
            borderRadius: '2px',
        };
    }
    if (isDraggingFrom) {
        return {
            background: 'rgba(8,64,248,0.02)',
            border: '1px dashed #82ACFF',
            borderRadius: '2px',
        };
    }
    return {
        background: 'white',
    };
};
// Using a higher order function so that we can look up the quotes data to retrieve
// our quote from within the rowRender function
const getRowRender = (quotes, prefixCls) => ({ index, style }) => {
    const quote = quotes[index];
    // We are rendering an extra item for the placeholder
    // Do do this we increased our data set size to include one 'fake' item
    if (!quote) {
        return null;
    }
    // Faking some nice spacing around the items
    const patchedStyle = {
        ...style,
        left: Number(style.left) + 8,
        top: Number(style.top) + 8,
        width: `calc(${style.width} - ${8 * 2}px)`,
        height: Number(style.height) - 8,
    };
    return (React.createElement(Draggable, { draggableId: String(quote.id), index: index, key: quote.id }, (provided, snapshot) => (React.createElement(QuoteItem, { provided: provided, quote: quote, isDragging: snapshot.isDragging, style: patchedStyle, prefixCls: prefixCls }))));
};
const Column = function Column(props) {
    const { columnId, quotes, prefixCls, className, header } = props;
    // console.log('quotes', quotes)
    const cls = classnames(`${prefixCls}-column-container`, {}, className);
    return (React.createElement("div", { className: cls },
        React.createElement("div", { className: `${prefixCls}-column-header` },
            React.createElement("span", null, header),
            React.createElement("span", { className: `${prefixCls}-column-header-count` },
                "(",
                quotes ? quotes.length : 0,
                ")")),
        React.createElement(Droppable, { droppableId: columnId, mode: "virtual", renderClone: (provided, snapshot, rubric) => (React.createElement(QuoteItem, { prefixCls: prefixCls, provided: provided, isDragging: snapshot.isDragging, quote: quotes && quotes[rubric.source.index], style: { margin: 0 } })) }, (droppableProvided, snapshot) => {
            const itemCount = quotes ? snapshot.isUsingPlaceholder
                ? quotes.length + 1
                : quotes.length : 0;
            return (React.createElement(List, { className: `${prefixCls}-column-list`, height: 500, rowCount: itemCount, rowHeight: 122, width: 332, ref: (ref) => {
                    // react-virtualized has no way to get the list's ref that I can so
                    // So we use the `ReactDOM.findDOMNode(ref)` escape hatch to get the ref
                    if (ref) {
                        // eslint-disable-next-line react/no-find-dom-node
                        const whatHasMyLifeComeTo = findDOMNode(ref);
                        if (whatHasMyLifeComeTo instanceof HTMLElement) {
                            droppableProvided.innerRef(whatHasMyLifeComeTo);
                        }
                    }
                }, style: getDraggingStyle(snapshot.isDraggingOver, Boolean(snapshot.draggingFromThisWith)), 
                // style={{
                //   backgroundColor: getBackgroundColor(
                //     snapshot.isDraggingOver,
                //     Boolean(snapshot.draggingFromThisWith),
                //   ),
                //   transition: 'background-color 0.2s ease',
                // }}
                rowRenderer: quotes ? getRowRender(quotes, prefixCls) : null }));
        })));
};
Column.displayName = 'Column';
export default observer(Column);
